import BasePolicy from '@/policies/BasePolicy.js';

export default class CourseAnnouncementPolicy extends BasePolicy {
    viewAny(user, course) {
        if (user.isStudentSupportOfCourse(course.id)) {
            return false;
        }

        return (
            user.hasPermissionViaCourseTo(course, 'view a course announcement') ||
            user.hasGroupPermissionWithinCourse(course, 'view a course announcement')
        );
    }

    view(user, courseAnnouncement) {
        return (
            user.hasPermissionViaCourseTo(courseAnnouncement.course, 'view a course announcement') ||
            user.hasGroupPermissionWithinCourse(courseAnnouncement.course, 'view a course announcement')
        );
    }

    create(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'create a course announcement') ||
            user.hasGroupPermissionWithinCourse(course, 'create a course announcement')
        );
    }

    update(user, courseAnnouncement) {
        return (
            user.id === courseAnnouncement.created_by &&
            (user.hasPermissionViaCourseTo(courseAnnouncement.course, 'edit a course announcement') ||
                user.hasGroupPermissionWithinCourse(courseAnnouncement.course, 'edit a course announcement'))
        );
    }

    delete(user, courseAnnouncement) {
        return (
            user.id === courseAnnouncement.created_by &&
            (user.hasPermissionViaCourseTo(courseAnnouncement.course, 'delete a course announcement') ||
                user.hasGroupPermissionWithinCourse(courseAnnouncement.course, 'delete a course announcement'))
        );
    }
}
